import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { benningtonConfig } from "./data";

export default function BenningtonPage() {
  return <CityPageTemplate config={benningtonConfig} />;
}